import {
  getPasskeyPreference,
  clearPasskeyPreference,
  setPasskeyPreference,
} from "./webauthn";

const ENTER_PASSWORD_KEY = "enterPassword";

function readPasswordPreference(forcePassword) {
  if (forcePassword) {
    localStorage.setItem(ENTER_PASSWORD_KEY, "true");
    return true;
  }

  return localStorage.getItem(ENTER_PASSWORD_KEY) === "true";
}

function writePasswordPreference(value) {
  localStorage.setItem(ENTER_PASSWORD_KEY, value ? "true" : "false");
}

window.loginForm = function loginForm(config = {}) {
  return {
    enterPassword: readPasswordPreference(
      config.forcePassword || config.skipPasskey
    ),
    selectedEmail: config.initialEmail || "",
    autoSubmitAttempted: false,
    autoSubmitInProgress: false,

    init() {
      if (config.skipPasskey) {
        clearPasskeyPreference();
      }

      if (this.enterPassword) {
        return;
      }

      const preference = getPasskeyPreference();

      if (preference?.email) {
        if (!this.selectedEmail) {
          this.selectedEmail = preference.email;
        }

        this.$nextTick(() => {
          this.triggerAutoSubmit();
        });
      }
    },

    switchToPasskey() {
      this.setPreference(false);
    },

    switchToPassword() {
      this.setPreference(true);
      clearPasskeyPreference();
    },

    submitPasskey() {
      if (!this.ensureEmailPresent()) {
        return false;
      }

      if (!this.autoSubmitInProgress) {
        this.autoSubmitAttempted = true;
      }

      this.setPreference(false, { skipAutoSubmit: true });
      this.autoSubmitInProgress = false;

      return true;
    },

    setPreference(usePassword, options = {}) {
      this.enterPassword = usePassword;
      writePasswordPreference(usePassword);

      if (!usePassword && !options.skipAutoSubmit) {
        this.autoSubmitAttempted = false;
        this.$nextTick(() => this.triggerAutoSubmit());
      }
    },

    ensureEmailPresent() {
      if (!this.selectedEmail) {
        return false;
      }

      if (this.$refs.email) {
        this.$refs.email.value = this.selectedEmail;
      }

      return this.$refs.email && this.$refs.email.value;
    },

    triggerAutoSubmit() {
      if (this.enterPassword || this.autoSubmitAttempted) {
        return;
      }

      if (!this.ensureEmailPresent()) {
        return;
      }

      const button = this.$refs.passkeyButton;
      if (!button) {
        return;
      }

      this.autoSubmitAttempted = true;
      this.autoSubmitInProgress = true;
      button.click();
    },
  };
};

window.updatePasskeyPreferenceAfterSuccess = function updatePasskeyPreferenceAfterSuccess(
  email
) {
  setPasskeyPreference(email);
};
